<div class="flex items-center justify-center">

    <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
        <div class="flex gap-2 items-center w-100">
            <a [routerLink]="['/venues']" class="back-button flex items-center justify-center gap-2 no-decoration">
                <i class="material-icons">arrow_back</i>
                <span>Back</span>
            </a>
            <h2 class="w-70 center-text">Add New Venue</h2>
        </div>
        <form class="w-100" #form="ngForm" (ngSubmit)="saveVenue(form)">
            <div class="input-group">
                <label for="name">Venue Name <span class="required-indicator">*</span></label>
                <input required type="text" [(ngModel)]="newVenue.name" id="name" name="name"
                    class="textbox p-10">
                <div *ngIf="form.submitted && form.controls.name?.invalid">
                    <small class="error-message">Venue Name is required</small>
                </div>
            </div>

            <div class="input-group">
                <label for="venue_description">Description</label>
                <quill-editor
                    [(ngModel)]="newVenue.venue_description"
                    [modules]="quillConfiguration"
                    [placeholder]="''"
                    name="venue_description"></quill-editor>
            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="capacity">Capacity</label>
                    <input type="number" [(ngModel)]="newVenue.capacity" id="capacity" name="capacity"
                        class="textbox p-10" min="1">
                </div>

                <div class="input-group">
                    <label for="tables">Tables</label>
                    <input type="number" [(ngModel)]="newVenue.tables" id="tables" name="tables"
                        class="textbox p-10" min="1">
                </div>
            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="private_client">
                        <input type="checkbox" [(ngModel)]="newVenue.private_client" name="private_client" id="private_client"
                            class="checkbox-input">
                        Private Client</label>
                </div>

                <div class="input-group">
                    <label for="test_venue">
                        <input type="checkbox" [(ngModel)]="newVenue.test_venue" name="test_venue" id="test_venue"
                            class="checkbox-input">
                        Testing/Training Venue</label>
                </div>
            </div>

            <div class="input-group">
                <label for="zone">Zone</label>
                <input type="number" [(ngModel)]="newVenue.zone" id="zone" name="zone"
                    class="textbox p-10" min="0" max="5" placeholder="0-5">
            </div>

            <div class="label-divider w-100">
                <span class="divider-line"></span>
                <p class="label">Address</p>
                <span class="divider-line"></span>
            </div>

            <div class="input-group">
                <label for="phone">Phone Number</label>
                <input type="text" [maxlength]="13" [(ngModel)]="newVenue.phone" id="phone" name="phone"
                    class="textbox p-10">
            </div>

            <div class="input-group">
                <label for="address">Address</label>
                <input type="text" [(ngModel)]="newVenue.address" id="address" name="address"
                    class="textbox p-10">
            </div>

            <div class="input-group">
                <label for="city">City <span class="required-indicator">*</span></label>
                <input type="text" [(ngModel)]="newVenue.city" id="city" name="city" required class="textbox p-10">
                <div *ngIf="form.submitted && form.controls.city?.invalid">
                    <small class="error-message">City is required</small>
                </div>
            </div>

            <div class="flex gap-2 w-100">
                <div class="input-group">
                    <label for="state">State <span class="required-indicator">*</span></label>
                    <input type="text" [maxlength]="2" [(ngModel)]="newVenue.state" name="state" id="state" required
                        class="textbox p-10">
                    <div *ngIf="form.submitted && form.controls.state?.invalid">
                        <small class="error-message">State is required</small>
                    </div>
                </div>
                <div class="input-group">
                    <label for="zip">ZIP Code <span class="required-indicator">&nbsp;</span> </label>
                    <input type="tel" [(ngModel)]="newVenue.zip_code" id="zip" name="zip_code" class="textbox p-10">
                </div>
            </div>

            <div class="label-divider w-100">
                <span class="divider-line"></span>
                <p class="label">Social Media</p>
                <span class="divider-line"></span>
            </div>

            <div class="input-group">
                <label for="site_url">Website</label>
                <input type="url" [(ngModel)]="newVenue.site_url" id="site_url" name="site_url"
                    class="textbox p-10" placeholder="https://example.com">
            </div>

            <div class="input-group">
                <label for="facebook">Facebook</label>
                <input type="url" [(ngModel)]="newVenue.facebook" id="facebook" name="facebook"
                    class="textbox p-10" placeholder="https://facebook.com/username">
            </div>

            <div class="input-group">
                <label for="twitter">X (Twitter)</label>
                <input type="url" [(ngModel)]="newVenue.twitter" id="twitter" name="twitter"
                    class="textbox p-10" placeholder="https://x.com/username">
            </div>

            <div class="input-group">
                <label for="instagram">Instagram</label>
                <input type="url" [(ngModel)]="newVenue.instagram" id="instagram" name="instagram"
                    class="textbox p-10" placeholder="https://instagram.com/username">
            </div>

            <p class="success-message" *ngIf="successMessage !== ''">{{ successMessage }}</p>
            <p class="error-message" *ngIf="errorMessage !== ''">{{ errorMessage }}</p>
            <button type="submit" class="back-button w-100 save-button">
                {{ isSavingInfo ? 'Saving...': 'Save Venue' }}
            </button>
        </form>
    </div>
</div>
